import React, { useEffect, useState, Fragment } from 'react';
import { Card, Col, Container, Form, Row, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { obtenerDatosGestionImplicado, obtenerTareasPendientes } from '../../store/actions/administracion-caso-action';
import Acciones from './acciones';
import GrillaTareasPendientes from './grilla-tareas-pendientes'
import { Auth } from 'recupero-comunes';

// Menu Flotante
import { makeStyles } from '@material-ui/core/styles';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import { AiOutlineMenuUnfold } from "react-icons/ai";
import { MdAccountBox, MdPeopleAlt, MdMonetizationOn, MdAccountBalance, MdLock, MdPayments } from "react-icons/md";
import { FaMoneyBillAlt, FaClipboardList } from "react-icons/fa";
import DetalleCierre from './confirmar-cierre/components/detalle-cierre';
import { serviceGetSolicitudGestion } from '../../api/api-confirmar-cierre';

import { ConsultaMovimientosComponent } from 'defcol-caso-general';
import { ConsultaContactoAseguradoComponent } from 'defcol-caso-general';
import { ConsultaContactoImplicadoComponent } from 'defcol-caso-general';
import { ConsultaProcesosJudicialesComponent } from 'defcol-caso-general';
import { ConsultaGastosHonorariosComponent } from 'defcol-caso-general';
import { ConsultaTrazabilidadHitosComponent } from 'defcol-caso-general';
import { ConsultaPagosEmitidosComponent } from 'defcol-caso-general';

import VisaProvisionesModal from './visar-provision';

const useStyles = makeStyles((theme) => ({
    root: {
        height: 380,
        transform: 'translateZ(0px)',
        flexGrow: 1,
    },
    speedDial: {
        position: 'absolute',
        top: '-350px',
        right: '-60px',
        zIndex: '150',
        /* marginTop: '-250px', */
        /* right: theme.spacing(5), */
    },
    menu: {
        width: '50px',
        height: '50px',
        zIndex: 250
    },
    tooltip: {
        fontSize: '12px',
        backgroundColor: 'black',
        color: 'white'
    }
}));
const useStylesToltip = makeStyles((theme) => ({
  tooltip: {
      fontSize: '12px',
      backgroundColor: 'black',
      color: 'white'
  }
}));
//

const AdministracionCaso = ({ formik, origen }) => {
    const dispatch = useDispatch();
    const [solicitud, setSolicitud] = useState(null);
    const [idCarpetaResExt, setIdCarpetaResExt] = useState('');
    const [ambitoGestion, setAmbitoGestion] = useState('');
    const [fecAudienciaFormat, setFecAudienciaFormat] = useState('');

    const [implicadoSeleccionado, setImplicadoSeleccionado] = useState('');
    const [ultimoHito, setUltimoHito] = useState('');
    const [fechaHito, setFechaHito] = useState('');

    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const data_admnistracion = useSelector((state) => state.administracionCasoReducer);
    const { llaves } = data_encargado;
    const { cfg_form43, datosGestionImplicado, datosGestionImplicadoDefault, listaImplicados } = data_admnistracion;

    // Menu FLotante
    const classes = useStyles();
    const classesTooltip = useStylesToltip();
    const [open, setOpen] = React.useState(false);
    const [hidden, setHidden] = React.useState(false);
    const handleOpen = () => { setOpen(true); };
    const handleClose = () => { setOpen(false); };

    const [showMovimiento, setShowMovimiento] = useState(false);
    const [showDetalleCierre, setShowDetalleCierre] = useState(false);
    const [showContactoAsegurado, setShowContactoAsegurado] = useState(false);
    const [showContactoImplicado, setShowContactoImplicado] = useState(false);
    const [showProcesosJudiciales, setShowProcesosJudiciales] = useState(false);
    const [showGastosHonorarios, setShowGastosHonorarios] = useState(false);
    const [showTrazabilidadHitos, setShowTrazabilidadHitos] = useState(false);
    const [showPagosEmitidos, setShowPagosEmitidos] = useState(false);

    const [action, setAction] = useState("");
    const [showVisarProvision, setShowVisarProvision] = useState(false);

    const actions = [
        { icon: <MdLock size={35} style={{ color: '#00aeab' }} />, name: 'Detalle del Cierre', id: '2' },        
        { icon: <FaClipboardList size={35} style={{ color: '#00aeab' }} />, name: 'Consulta Trazabilidad Hitos', id: '7' },
        { icon: <MdPayments size={35} style={{ color: '#00aeab' }} />, name: 'Consulta Pagos Emitidos', id: '8' },
        { icon: <FaMoneyBillAlt size={35} style={{ color: '#00aeab' }} />, name: 'Consulta Gastos Honorarios-Provisiones', id: '6' },        
        { icon: <MdMonetizationOn size={35} style={{ color: '#00aeab' }} />, name: 'Consulta de Movimientos', id: '1' },                        
        { icon: <MdAccountBalance size={35} style={{ color: '#00aeab' }} />, name: 'Consulta Procesos Judiciales', id: '5' },
        { icon: <MdPeopleAlt size={35} style={{ color: '#00aeab' }} />, name: 'Consulta Contacto Implicado', id: '3' },
        { icon: <MdAccountBox size={35} style={{ color: '#00aeab' }} />, name: 'Consulta Contacto Asegurado', id: '4' },
    ];
    //

    useEffect(() => {
        if (llaves) getSolicitudGestion();
    }, [llaves])

    useEffect(() => {
        setIdCarpetaResExt(
            datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado.length > 0 &&
                datosGestionImplicadoDefault.datosGestionImplicado[0] && datosGestionImplicadoDefault.datosGestionImplicado[0]['idCarpetaResExt']
                ? datosGestionImplicadoDefault.datosGestionImplicado[0]['idCarpetaResExt'] : ''
        )

        setAmbitoGestion(
            datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado.length > 0 &&
                datosGestionImplicadoDefault.datosGestionImplicado[0] && datosGestionImplicadoDefault.datosGestionImplicado[0]['ambitoGestion']
                ? datosGestionImplicadoDefault.datosGestionImplicado[0]['ambitoGestion'] : ''
        )

        setFecAudienciaFormat(
            datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado.length > 0 &&
                datosGestionImplicadoDefault.datosGestionImplicado[0] && datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat']
                ? datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat'] : ''
        )
    }, [datosGestionImplicadoDefault])

    useEffect(() => {
        setUltimoHito(
            datosGestionImplicado && datosGestionImplicado.datosGestionImplicado.length > 0 &&
                datosGestionImplicado.datosGestionImplicado[0] && datosGestionImplicado.datosGestionImplicado[0]['ultimoHitoCaso']
                ? datosGestionImplicado.datosGestionImplicado[0]['ultimoHitoCaso'] : ''
        )

        setFechaHito(
            datosGestionImplicado && datosGestionImplicado.datosGestionImplicado.length > 0 &&
                datosGestionImplicado.datosGestionImplicado[0] && datosGestionImplicado.datosGestionImplicado[0]['fechaUltimoHitoFormat']
                ? datosGestionImplicado.datosGestionImplicado[0]['fechaUltimoHitoFormat'] : ''
        )
    }, [datosGestionImplicado])

    const getSolicitudGestion = async () => {
        let query = Buffer.from(JSON.stringify({ idCaso: llaves?.idCaso, idImplicado: 0, grupoSolGestion: 246002 })).toString('base64');
        const response = await serviceGetSolicitudGestion(query);

        setSolicitud(response && response.length > 0 ? response[0] : null);
    }

    const handleChangeSelect = (value) => {
        formik.handleChange;
        setImplicadoSeleccionado(value);

        if (value !== "") {
            let query = Buffer.from(JSON.stringify({ "idCaso": llaves["idCaso"], "idImplicado": value })).toString('base64')
            dispatch(obtenerDatosGestionImplicado(query));
        } else {
            setUltimoHito('');
            setFechaHito('');
        }
    }

    const recargarTareasPendientes = () => {
        let query = Buffer.from(JSON.stringify({ "idCaso": llaves["idCaso"], "idUsuario": Auth.currentUser().rutUsuario })).toString('base64');
        dispatch(obtenerTareasPendientes(query))
    }

    const handleAction = async (action) => {
        if (action === "1") setShowMovimiento(true);  // Consulta Movimientos
        if (action === "2") setShowDetalleCierre(true);  // Detalle del Cierre
        if (action === "3") setShowContactoImplicado(true);  // Consulta Contacto Implicado
        if (action === "4") setShowContactoAsegurado(true);  // Consulta Contacto Asegurado
        if (action === "5") setShowProcesosJudiciales(true);  // Consulta Procesos Juduiciales
        if (action === "6") setShowGastosHonorarios(true);  // Consulta Gastos Honorarios Provisiones
        if (action === "7") setShowTrazabilidadHitos(true);  // Consulta Trazabilidad Hitos
        if (action === "8") setShowPagosEmitidos(true);  // Consulta Pagos Emitidos
    }
     useEffect(() => {
        if (listaImplicados && listaImplicados.listaImplicados && listaImplicados.listaImplicados.length === 1) {          
            let idImplicado = listaImplicados.listaImplicados[0].IdImplicado;
            formik.setFieldValue('implicados', 1);
            setImplicadoSeleccionado(idImplicado)
            let query = Buffer.from(JSON.stringify({ "idCaso": llaves["idCaso"], "idImplicado": idImplicado })).toString('base64')
            dispatch(obtenerDatosGestionImplicado(query));
        }    
    }, [listaImplicados])
    const handleShowModalIngresoReserva = () => {
        setAction("valpec");
        setShowVisarProvision(true); 
    } 
    return (
        <Fragment>
            <VisaProvisionesModal
                action={action}
                showModal={showVisarProvision}
                setShowModal={setShowVisarProvision}
                implicado={implicadoSeleccionado}
                origenVisar={100}//Se utiliza numero ficticio
                idTrxOrigen={null}
            />
            <ConsultaMovimientosComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                codClasCaso={datosGestionImplicadoDefault?.datosGestionImplicado[0]?.codClasCaso}
                showModal={showMovimiento}
                setShowModal={setShowMovimiento}
            />

            <ConsultaContactoAseguradoComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                tipoGestion={datosGestionImplicadoDefault?.datosGestionImplicado[0]?.codTipoGestion}
                showModal={showContactoAsegurado}
                setShowModal={setShowContactoAsegurado}
            />

            <ConsultaContactoImplicadoComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                tipoGestion={datosGestionImplicadoDefault?.datosGestionImplicado[0]?.codTipoGestion}
                showModal={showContactoImplicado}
                setShowModal={setShowContactoImplicado}
            />

            <ConsultaProcesosJudicialesComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                tipoGestion={datosGestionImplicadoDefault?.datosGestionImplicado[0]?.codTipoGestion}
                showModal={showProcesosJudiciales}
                setShowModal={setShowProcesosJudiciales}
            />

            <ConsultaGastosHonorariosComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                showModal={showGastosHonorarios}
                setShowModal={setShowGastosHonorarios}
            />

            <ConsultaTrazabilidadHitosComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                tipoGestion={datosGestionImplicadoDefault?.datosGestionImplicado[0]?.codTipoGestion}
                showModal={showTrazabilidadHitos}
                setShowModal={setShowTrazabilidadHitos}
            />

            <ConsultaPagosEmitidosComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                showModal={showPagosEmitidos}
                setShowModal={setShowPagosEmitidos}
            />

            <DetalleCierre
                showModal={showDetalleCierre}
                setShowModal={setShowDetalleCierre}
                implicado={0}
                solicitud={solicitud}
            />

            <Container className='mb-4 mt-2 position-relative'>
                <SpeedDial
                    ariaLabel="SpeedDial tooltip example"
                    className={classes.speedDial}
                    hidden={hidden}
                    icon={<AiOutlineMenuUnfold size={30} />}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    open={true}
                >
                    {actions.map((action) => (
                        <SpeedDialAction
                            key={action.id}
                            icon={action.icon}
                            tooltipTitle={action.name}
                            className={classes.menu}
                            onClick={() => handleAction(action.id)}
                            TooltipClasses={classesTooltip}
                        />
                    ))}
                </SpeedDial>

                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        {cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-title-tareas-pend'] : ''}
                        <OverlayTrigger overlay={<Tooltip id='tooltip-disabled'>Recargar Tareas Pendientes </Tooltip>}>
                            <Button type="button" style={{ float: 'right', backgroundColor: 'white', color: 'black' }} variant="outline-secondary" size="sm" onClick={() => recargarTareasPendientes()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                </svg>
                            </Button>
                        </OverlayTrigger>
                    </Card.Header>
                    <Card.Body style={{ paddingBottom: '0' }}>
                        <GrillaTareasPendientes />
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        {cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-title-gestion-reserva'] : ''}                        
                    </Card.Header>
                    <Card.Body style={{ paddingBottom: '0' }}>
                        <Row>
                            <Col md="5">
                                <Form.Label className='mb-0 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-cmb-implicados'] : ''}
                                </Form.Label>{' '}
                                <br />
                                <Form.Select
                                    style={{ width: '70%' }}
                                    className='mt-2'
                                    name='implicados'
                                    onChange={(e) => handleChangeSelect(e.target.value)}
                                    value={implicadoSeleccionado}
                                >
                                    <option value={''}>Seleccione...</option>
                                    {listaImplicados && listaImplicados.listaImplicados?.map((c) => (
                                        <option key={c.IdImplicado} value={c.IdImplicado}>{c.NombreImplicadoCmb}</option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col md="3">
                                <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-lbl-ultimohito'] : ''}
                                </Form.Label>
                                <br />
                                <Form.Text className="mt-5">{ultimoHito}</Form.Text>
                            </Col>
                            <Col md="2">
                                <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-lbl-fechahito'] : ''}
                                </Form.Label>
                                <br />
                                <Form.Text className="mt-5">{fechaHito}</Form.Text>
                            </Col>
                            <Col md="2">
                                <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}><br /></Form.Label>
                                <Button disabled={!implicadoSeleccionado} className='m-2' variant='ultima-reserva' onClick={handleShowModalIngresoReserva}>
                                    {cfg_form43 && cfg_form43.cfg_form43["formbasegestiondefensacia-btn-ult-reserva"]}
                                </Button>
                            </Col>
                        </Row>
                        <br />
                    </Card.Body>
                </Card>
                <br />
                <Card>
                    <Acciones implicadoSeleccionado={implicadoSeleccionado} origen={origen}/>
                </Card>
            </Container>
            <style type='text/css'>
                {`
                .btn-ultima-reserva {
                    background-color: #55B2CE;
                    color: #FFFFFF;
                    width: 140px;
                }
                .btn-ultima-reserva:hover{
                    background-color: #87c9dc;
                    color: #FFFFFF;
                } 
            `}
            </style>
        </Fragment>
    )
}

export default AdministracionCaso